import { Resource } from 'app/shared/abstract.resource.entity';
import { CategoriesDto } from './categories.dto';

export class CategoriesSerializer {
  static fromJson(json: any): Resource {
    const category = new CategoriesDto();
    category.id = json.ID;
    category.name = json.DESCRIPTION;
    category.fatherCode = json.FATHERID;

    return category;
  }
  static toJson(resource: any) {
    return {
      ID: resource.id,
      DESCRIPTION: resource.name,
      FATHERID: resource.fatherCode,
    };
  }
}
